import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type UIState = {
  waitlistModalVisible: boolean;
  setWaitlistModalVisible: (visible: boolean) => void;

  videoPlayerVisible: boolean;
  videoPlayerLink: string | null;
  showVideoPlayerVisible: (link: string) => void;
  hideVideoPlayerVisible: () => void;
  quizModalVisible: boolean;
  setQuizModalVisible: (visible: boolean) => void;

  waitlistEmail: string | null;
  setWaitlistEmail: (email: string | null) => void;

  hasSignedUp: boolean;
  setHasSignedUp: (val: boolean) => void;
};

export const uiStore = create<UIState>()(
  persist(
    (set) => ({
      waitlistModalVisible: false,
      quizModalVisible: false,
      videoPlayerVisible: false,
      videoPlayerLink: null,

      setWaitlistModalVisible: (visible: boolean) => set({ waitlistModalVisible: visible }),

      setQuizModalVisible: (visible: boolean) => set({ quizModalVisible: visible }),

      waitlistEmail: null,
      setWaitlistEmail: (email: string | null) => set({ waitlistEmail: email }),

      hasSignedUp: false,
      setHasSignedUp: (val: boolean) => set({ hasSignedUp: val }),

      showVideoPlayerVisible: (link: string) =>
        set({
          videoPlayerLink: link,
          videoPlayerVisible: true,
        }),

      hideVideoPlayerVisible: () =>
        set({
          videoPlayerVisible: false,
          videoPlayerLink: null,
        }),
    }),
    {
      name: 'ui-storage',
    },
  ),
);
